<template>
    <!-- 弹出框查看 -->
    <div>
      <el-form ref="form" :model="rowdata" :rules="rules" label-width="160px">
        <el-form-item label="议题分类:">
          <el-input size="mini" style="width:50%" disabled v-model="rowdata.consultCut"></el-input>
        </el-form-item>
        <el-form-item label="议题名称:">
          <el-input size="mini" style="width:50%" disabled v-model="rowdata.consultName"></el-input>
        </el-form-item>
        <el-form-item label="关键词:">
          <el-input size="mini" style="width:50%" disabled v-model="rowdata.keyword"></el-input>
        </el-form-item>
        <el-form-item label="召开时间:">
          <el-input size="mini" style="width:50%" disabled v-model="rowdata.holdingTime"></el-input>
        </el-form-item>
        <el-form-item label="所属社区组织:" style="margin:0 30 0 0;">
          <el-select disabled size="mini" style="width:20%" v-model="rowdata.orgPid" placeholder="--请选择--">
            <el-option v-for="item in selectOrgs1" :key="item.value"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          ~
            <el-select disabled size="mini" style="width:28%" v-model="rowdata.orgId" placeholder="--请选择--">
            <el-option v-for="item in selectOrgs2" :key="item.value"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="召开地点:">
          <el-input size="mini" style="width:50%" disabled v-model="rowdata.place"></el-input>
        </el-form-item>
        <el-form-item label="内容:" style="margin-bottom: 120px">
          <quillEditor v-model="rowdata.content" disabled :options="editorOption" style="height:150px"></quillEditor>
        </el-form-item>
        <el-form-item label="上传附件：" prop="enclosure">
          <el-upload :file-list="fileList" action="" :disabled="true" :auto-upload="false">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="两委代表:" v-if="rowdata.representative.length > 0" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.representative" :key="tag.id">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item label="两新代表:" v-if="rowdata.organization.length > 0" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.organization" :key="tag.id">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item label="专业人士:" v-if="rowdata.professional.length > 0" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.professional" :key="tag.name">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item label="利益方:" v-if="rowdata.interestParty.length > 0" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.interestParty" :key="tag.id">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item v-if="rowdata.someoneElse.length > 0" label="其它人员:" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.someoneElse" :key="tag.id">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <!-- 审批结果 -->
        <el-form-item label="展示顺序: ">
          <el-input v-model="rowdata.sort" size="mini" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="审批结果: ">
          <el-radio-group v-model="rowdata.approvalStatus" disabled>
            <el-radio label="1">同意</el-radio>
            <el-radio label="2">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见: ">
          <el-input type="textarea" style="width:50%" disabled :rows="2" placeholder="请输入内容" v-model="rowdata.approvalOpinion"></el-input>
        </el-form-item>
        <!-- 协商结果 -->
        <el-form-item label="利益方满意度: ">
          <el-radio-group v-model="rowdata.satisfaction" disabled>
            <el-radio label="0">双方满意</el-radio>
            <el-radio label="1">一方不满意</el-radio>
            <el-radio label="2">多方不满意</el-radio>
            <el-radio label="3">协商未果</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="协商结果描述:" style="margin-top: 10px;margin-bottom: 120px">
          <quillEditor v-model="rowdata.results" disabled :options="editorOption" style="height:150px"></quillEditor>
        </el-form-item>
        <el-form-item label="视频资料：">
          <video v-if="rowdata.video !=''" :src="rowdata.video" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
        </el-form-item>
        <el-form-item v-if="rowdata.responsible.length > 0" label="指派负责人:" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.responsible" :key="tag.name">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item v-if="rowdata.assist.length > 0" label="协助人员:" style="margin-top: 10px;">
          <el-tag v-for="tag in rowdata.assist" :key="tag.name">
            {{tag.name}}（{{tag.phone}}）
          </el-tag>
        </el-form-item>
        <el-form-item label="任务完成截止时间:">
          <el-date-picker v-model="rowdata.endTime" disabled type="date" value-format="yyyy-MM-dd" size="mini" style="width:50%" placeholder="选择日期" ></el-date-picker>
        </el-form-item>
        <!-- 点评 -->
        <el-form-item label="处理结果满意度: " prop="result">
          <el-radio-group v-model="rowdata.result">
            <el-radio label="0">双方满意</el-radio>
            <el-radio label="1">一方不满意</el-radio>
            <el-radio label="2">多方不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="处理结果综合评价: " prop="evaluate" style="margin-bottom: 10px">
          <el-input type="textarea" style="width:50%" :rows="4" placeholder="请输入内容" v-model="rowdata.evaluate"></el-input>
        </el-form-item>
        <el-form-item label="处理速度: " prop="speed" >
          <el-rate size="large" v-model="rowdata.speed" :colors="['#99A9BF', '#F7BA2A', '#FF9900']" style="margin-top: 11px;"> </el-rate>
        </el-form-item>
        <el-form-item label="执行人员的工作态度: " prop="attitude">
          <el-radio-group v-model="rowdata.attitude">
            <el-radio label="0">满意</el-radio>
            <el-radio label="1">一般</el-radio>
            <el-radio label="2">不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="事件处理结果满意度: " prop="consulResult">
          <el-radio-group v-model="rowdata.consulResult">
            <el-radio label="0">满意</el-radio>
            <el-radio label="1">一般</el-radio>
            <el-radio label="2">不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话回访情况: " prop="returnVisit" style="margin-bottom: 10px">
          <el-input type="textarea" style="width:50%" :rows="4" placeholder="请输入内容" v-model="rowdata.returnVisit"></el-input>
        </el-form-item>
        <el-form-item label="需要改进的地方: " prop="improvement" style="margin-bottom: 10px">
          <el-input type="textarea" style="width:50%" :rows="4" placeholder="请输入内容" v-model="rowdata.improvement"></el-input>
        </el-form-item>
        <el-form-item label="推荐案例: " prop="cases">
          <el-radio-group v-model="rowdata.cases">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="案例展示图片:" prop="casesPhoto">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
            :on-success="uploadSuccess" :before-upload="beforeAvatarUpload" name="file">
            <img v-if="rowdata.casesPhoto" :src="rowdata.casesPhoto" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button type="primary" size="small" style="margin: 0 30px" @click="saveData">保存</el-button>
        <el-button type="info" size="small" @click="closeDialog">关闭</el-button>
      </div>
    </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from '../../../../utils/editorOption.js'
import request from "../../../../utils/request.js"
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: 'ViewReviews',
  props: ["rowid"],
  components: {
    quillEditor
  },
  data() {
    return {
      id: this.rowid,
      editorOption: editor_option.editorOption,
      uploadUrl: request.defaults.baseURL + '/consul/info/uplodfile',
      rowdata: {},
      fileList: [],
      selectOrgs1: [],
      selectOrgs2: [],
      rules: {
        result: [
          { required: true, message: '请选择处理结果综合评价', trigger: 'blur' }
        ],
        speed: [
          { required: true, message: '请选择处理速度', trigger: 'blur' }
        ],
        evaluate: [
          { required: true, message: '请输入综合评价', trigger: 'blur' }
        ],
        attitude: [
          { required: true, message: '执行人员的工作态度', trigger: 'blur' }
        ],
        consulResult: [
          { required: true, message: '请选择处理结果满意度', trigger: 'blur' }
        ],
        cases: [
          { required: true, message: '请选择是否推荐', trigger: 'blur' }
        ],
        returnVisit: [
          { required: true, message: '请输入电话回访', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    //获取所属组织
    async getOrg(selVal) {
      let fd = new FormData()
      fd.append("token", token)
      //获取父类
      if(selVal == ''){
        fd.append("parentId", 0)
        var res = await request({
           url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        })
        var temp = {}
        if(res.content.length > 0 ){
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName }
            this.selectOrgs1.push(temp)
          });
        }
      }else{ //获取子组织
        fd.append("parentId", selVal)
        var res = await request({
           url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        })
        this.selectOrgs2 = []
        var temp = {}
        if(res.content.length > 0 ){
          this.allOrgs = res.content
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName }
            this.selectOrgs2.push(temp)
          });
        }
      }
    },
    //点击查看显示弹出层
    async getData() {
      this.rowdata = {
        representative: [],
        professional: [],
        organization: [],
        interestParty: [],
        someoneElse: [],
        responsible: [],
        assist: []
      }
      if(this.id != ''){
        //获取编辑项的最新数据
        let fd = new FormData()
        fd.append("token", token)
        fd.append("id", this.id)
        var res = await request({
           url: "/admin/consul/info/findConsultById",
          method: "POST",
          data: fd
        })
        // console.log(res)
        if (res.code == 200) {
          res.content.representative = this.rowdata.representative
          res.content.professional = this.rowdata.professional
          res.content.organization = this.rowdata.organization
          res.content.interestParty = this.rowdata.interestParty
          res.content.someoneElse = this.rowdata.someoneElse
          res.content.responsible = this.rowdata.responsible
          res.content.assist = this.rowdata.assist
          this.rowdata = res.content
          //将字符串类型转换整型，select框中返回ID为整型
          this.rowdata.orgPid = parseInt(this.rowdata.orgPid)
          this.rowdata.orgId = parseInt(this.rowdata.orgId)
          this.getOrg(this.rowdata.orgPid)
          this.fileList = []
          var temp = {}
          if(res.content.enclosurePath != null && res.content.enclosurePath != ""){
            var namesArr = []
            if(res.content.enclosureName != null && res.content.enclosureName != ""){
              namesArr = res.content.enclosureName.split(',')
            }
            var enclosureArr = res.content.enclosurePath.split(',')
            enclosureArr.forEach((item,index) => {
              if(item != ''){
                temp = { name: namesArr[index]?namesArr[index]:('附件'+index) , url: item }
                this.fileList.push(temp)
              }
            })
          }
          //拆分consultRelation人员关系字段
          if(this.rowdata.consultRelationList.length > 0){
            var temp = {}
            this.rowdata.consultRelationList.forEach((item,index) => {
              temp = {id: item.id, name: item.name, phone: item.phone}
              if(item.persongType == 'Representative'){
                this.rowdata.representative.push(temp)
              }else if(item.persongType == 'Professional'){
                this.rowdata.professional.push(temp)
              }else if(item.persongType == 'Organization'){
                this.rowdata.organization.push(temp)
              }else if(item.persongType == 'InterestParty'){
                this.rowdata.interestParty.push(temp)
              }else if(item.persongType == 'SomeoneElse'){
                this.rowdata.someoneElse.push(temp)
              }else if(item.persongType == 'Responsible'){
                this.rowdata.responsible.push(temp)
              }else if(item.persongType == 'Assist'){
                this.rowdata.assist.push(temp)
              }
            })
          }
        }else{
          this.rowdata = {}
          console.log(res.code + '：' +res.message)
          this.$message({
            message: "数据项加载异常",
            type: "error"
          })
        }
      }else{
        this.$message({
          message: "数据传输异常",
          type: "error"
        })
        this.rowdata = {}
        this.$emit('func',[])
      }
    },
    //审批接口
    async saveData() {
      if (this.rowdata.result == "" || this.rowdata.evaluate=='') {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false
      }
      let fd = new FormData()
      fd.append("token", token)
      let paramsArr = {
        id: this.rowdata.id,
        result: this.rowdata.result,
        evaluate: this.rowdata.evaluate,
        speed: this.rowdata.speed,
        attitude: this.rowdata.attitude,
        consulResult: this.rowdata.consulResult,
        returnVisit: this.rowdata.returnVisit,
        improvement: this.rowdata.improvement,
        cases: this.rowdata.cases,
        casesPhoto: this.rowdata.casesPhoto,
        status: '3'  //点评结束
      }
      let params = JSON.stringify(paramsArr);
      fd.append("commentResults", params)
      console.log(params)
      var res = await request({
         url: "/admin/consul/info/commentResults",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: '点评成功',
          type: "success"
        });
        this.$emit('func',[])
      }else{
        console.log(res)
        this.$message({
            message: "点评失败：" + res.message,
            type: "error"
          });
      }
    },
    beforeAvatarUpload(file) {
      const isLtM = file.size / 1024 / 1024 < 2
      if (!isLtM) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLtM
    },
    uploadSuccess(response, file, fileList) {
      console.log(response)
      if(response.code == 200 && response.content != '' && response.content != null){
        this.rowdata.casesPhoto = response.content.path
      }
    },
    closeDialog() {
      this.$emit('func',[])
    }
  },
  mounted() {
    this.getOrg('')
  },
  beforeDestroy () {
  }
};
</script>

<style lang="less" scoped>
.avatar {
  width: 50%;
  float: left;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 600px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    border: 1px dashed #d9d9d9;
  }
  .avatar {
    width: 600px;
    height: 200px;
    display: block;
  }

.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
  min-width: 100%;
}
.el-form-item {
  margin-bottom: 1px;
}
.el-dialog__header {
  height: 40px;
  padding: 1px;
  background-color: #01aaef;
}
.el-dialog__headerbtn {
  position: absolute;
  top: 8px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 24px;
}
.el-dialog__title {
  display: block;
  margin-top: 9px;
  margin-left: 10px;
  color: #fff;
  font-size: 15px;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.el-progress-bar__inner {
  background-color: #93e3fc;
}
.el-progress-bar__outer {
  background-color: #01aaef;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>